<template>
    <PopForm v-if="show" width="990px" body-max-height="560px">
        <template v-slot:title>
            {{title}}
            <span class="close" @click="close">
                <i class="el-icon-close"></i>
            </span>
        </template>
        <div class="history-box">
            <!--搜索栏-->
            <div class="search-box">
                <el-date-picker
                        v-model="searchData.startDate"
                        type="date"
                        placeholder="选择开始日期"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions">
                </el-date-picker>&nbsp;&nbsp;
                <el-date-picker
                        v-model="searchData.endDate"
                        type="date"
                        placeholder="选择结束日期"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions">
                </el-date-picker>&nbsp;&nbsp;
                <el-select v-model="searchData.state">
                    <el-option value="" label="所有状态"></el-option>
                    <el-option value="1" label="有效"></el-option>
                </el-select>&nbsp;&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="searchEvent">搜索</el-button>
            </div>

            <!--数据列表-->
            <el-table :data="tableData" class="list-box" height="440">
                <el-table-column prop="name" label="名称" show-overflow-tooltip width="180">
                    <template slot-scope="scope">
                        {{scope.row.title}}
                        <span v-if="scope.row.count_type !== '2'">( {{scope.row.count_num}}次 )</span>
                    </template>
                </el-table-column>
                <el-table-column prop="state" label="状态" width="80">
                    <template slot-scope="scope">
                        <span v-if="scope.row.deduct_state">有效</span>
                        <span v-else style="color: #999999">失效</span>
                    </template>
                </el-table-column>
                <el-table-column prop="valid_day" label="有效期至" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.valid_day > 0">{{scope.row.expire_datetime}}</span>
                        <span v-else>永久有效</span>
                    </template>
                </el-table-column>
                <el-table-column prop="count_type" label="卡项类别" width="80">
                    <template slot-scope="scope">
                        <span v-if="scope.row.count_type === '1'">次卡</span>
                        <span v-else-if="scope.row.count_type === '2'">时卡</span>
                        <span v-else-if="scope.row.count_type === '3'">通卡</span>
                    </template>
                </el-table-column>
                <el-table-column prop="mobile" label="购买人" width="120">
                    <template slot-scope="scope">
                        {{scope.row.name}}<br/>{{scope.row.mobile}}
                    </template>
                </el-table-column>
                <el-table-column prop="create_datetime" label="购买时间" width="100" />
                <el-table-column prop="use_num" label="已用" width="80">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleUseView(scope.row)">
                            {{scope.row.use_num}}
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="pay_price" label="剩余" width="80">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleSurplusView(scope.row)">
                            {{scope.row.surplus_num}}
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleEdit(scope.$index, scope.row)">
                            查看权益
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!--底部-->
        <template v-slot:foot>
            <div class="page-box">
                <el-pagination
                        @size-change="pageSizeChange"
                        @current-change="pageCurrentChange"
                        :current-page="page.nowPage"
                        :page-sizes="page.pageSizes"
                        :page-size="page.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="page.count">
                </el-pagination>
            </div>
        </template>

        <!--权益-->
        <card-sale-history-product v-model="cardProductState" :card-info="cardInfo" />
        <!--使用记录-->
        <store-user-card-use-history v-model="cardUseHistoryState" :card-info="cardInfo"  />
        <!--剩余详情-->
        <store-user-card-surplus-info v-model="cardUseSurplusState" :card-info="cardInfo" />
    </PopForm>
</template>

<script>
    import obj from "@/js/obj";
    import CardSaleHistoryProduct from "@/model/Card/CardSaleHistoryProduct";
    import StoreUserCardUseHistory from "@/model/StoreUser/StoreUserCardUseHistory";
    import StoreUserCardSurplusInfo from "@/model/StoreUser/StoreUserCardSurplusInfo";
    import PopForm from "@/model/PopForm";
    export default {
        name: "CardSaleHistoryForCash",
        components: {
            PopForm,
            StoreUserCardSurplusInfo, StoreUserCardUseHistory, CardSaleHistoryProduct},
        model: {
            prop: "show",
            event: "showChange"
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            storeUid: {
                type: [String, Number],
                default: ""
            }
        },
        data: () => ({
            title: "卡项记录",
            tableData: [],
            searchData: {
                startDate: "",
                endDate: "",
                state: "1"
            },
            page: {
                nowPage: 1,
                pageSize: 50,
                pageSizes: [50, 100, 200, 400],
                count: 0,
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },

            //权益
            cardProductState: false,
            cardInfo: {},
            //状态
            cardUseHistoryState: false,
            cardUseSurplusState: false,
        }),
        methods: {
            //加载数据
            loadHistoryData: function () {
                let postData = {
                    page: this.page.nowPage,
                    limit: this.page.pageSize,
                    store_uid: this.storeUid,
                    start_date: this.searchData.startDate,
                    end_date: this.searchData.endDate,
                };
                let url = "card/get_sale_history";
                if(this.searchData.state === "1"){
                    url = "card/get_sale_history_valid";
                }
                obj.postData(url, postData, res => {
                    if(res.errcode === 0){
                        this.tableData = res.data;
                        this.page.count = res.count;
                    }
                });
            }

            //每页显示数量变化
            ,pageSizeChange: function (val) {
                this.page.pageSize = val;
                this.loadHistoryData();
            }

            //当前页码变化
            ,pageCurrentChange: function (val) {
                this.page.nowPage = val;
                this.loadHistoryData();
            }

            //关闭
            ,close: function () {
                this.$emit("showChange", false);
            }

            //搜索
            ,searchEvent: function () {
                this.loadHistoryData();
            }

            //查看权益
            ,handleEdit: function (index, data) {
                this.cardInfo = data;
                this.cardProductState = true;
            }

            //查看使用记录
            ,handleUseView: function (data) {
                this.cardInfo = data;
                this.cardUseHistoryState = true;
            }

            //查看剩余记录
            ,handleSurplusView: function (data) {
                this.cardInfo = data;
                this.cardUseSurplusState = true;
            }
        },
        watch: {
            show(val){
                if(val) this.loadHistoryData();
                else {
                    this.tableData = [];
                    this.searchData = {
                        startDate: "",
                        endDate: "",
                        state: "1"
                    };
                    this.page = {
                        nowPage: 1,
                        pageSize: 50,
                        pageSizes: [50, 100, 200, 400],
                        count: 0,
                    };
                }
            }
        }
    }
</script>

<style scoped>
    .close{
        float: right;
        line-height: 24px;
    }
    .history-box{
        /*height: 500px;*/
        overflow: hidden;
        padding: 0px 10px;
    }
    .search-box{
        margin-top: 10px;
    }
    .list-box{
        margin-top: 20px;
    }
    .page-box{
        flex: 2;
        text-align: right;
        border-top: none;
    }
</style>
